const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const headers = {
  'Content-Type': 'application/json',
};

const handleResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = (data && data.message) || response.statusText;
    throw new Error(error);
  }
  return data;
};

// Simple in-memory GET cache keyed by endpoint.
const memCache = new Map();

export const api = {
  get: (endpoint) => fetch(`${BASE_URL}${endpoint}`, {
    method: 'GET',
    headers,
    credentials: 'include',
  }).then(handleResponse),

  post: (endpoint, body) => fetch(`${BASE_URL}${endpoint}`, {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
    credentials: 'include',
  }).then(handleResponse),

  put: (endpoint, body) => fetch(`${BASE_URL}${endpoint}`, {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
    credentials: 'include',
  }).then(handleResponse),

  delete: (endpoint) => fetch(`${BASE_URL}${endpoint}`, {
    method: 'DELETE',
    headers,
    credentials: 'include',
  }).then(handleResponse),

  getCached: (key) => Promise.resolve(memCache.get(key) || null),
  setCache: (key, data) => { memCache.set(key, data); return Promise.resolve(data); },
  clearCache: () => { memCache.clear(); return Promise.resolve(); },
};
